import { handleLimitError } from './utils/limitErrors'

// Config compartida para todas las tablas DataTables de la app: por
// defecto 10 registros por página. No hay opción "Todos": cargar de una vez
// un listado entero (documentos, contactos...) es justo lo que hay que
// evitar. Se define en español a mano (en vez de cargar el paquete de
// idioma completo por URL) para poder fijar "_MENU_"/"" sin que la
// respuesta async del idioma los pise al llegar.
export const dataTableLengthMenu = [10, 25, 50, 100]
export const dataTableEsLanguage = {
    lengthMenu: "_MENU_",
    search: "",
    searchPlaceholder: "Búsqueda",
    // "Anterior"/"Siguiente" como iconos (tabler.io chevron-left/right) en
    // vez de texto, siguiendo el resto de iconografía de la app.
    paginate: {
        first: "Primero",
        previous: "<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M15 6l-6 6l6 6'/></svg>",
        next: "<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M9 6l6 6l-6 6'/></svg>",
        last: "Último"
    },
    info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
    infoEmpty: "Mostrando 0 a 0 de 0 registros",
    infoFiltered: "(filtrado de _MAX_ registros totales)",
    zeroRecords: "No se encontraron resultados",
    emptyTable: "No hay datos disponibles en la tabla"
}

// Oculta los enlaces de paginación (Anterior/1/2/.../Siguiente) cuando la
// tabla cabe entera en una sola página: pocos resultados, o una página
// larga elegida en el desplegable de registros por página.
// "draw.dt" es un evento nativo de DataTables que salta en cualquier tabla
// de la página tras cada dibujado (cambio de página, de filtro, de
// longitud, y también el dibujado inicial). Se engancha aquí, a nivel de
// módulo, para que esté escuchando en document ANTES de que exista
// cualquier tabla — si se enganchara de forma perezosa (p.ej. dentro de
// enhanceDataTableLength, llamada en un setTimeout tras el primer
// .dataTable()), se perdía siempre el dibujado inicial de la primera
// tabla de cada carga de página (el evento se dispara de forma síncrona
// al iniciar el plugin, antes de que el setTimeout llegara a ejecutarse),
// y solo funcionaba a partir de la segunda tabla visitada en la sesión.
if (window.$) {
    window.$(document).on('draw.dt', function (e) {
        const $ = window.$
        const api = new $.fn.dataTable.Api(e.target)
        const $wrapper = $(api.table().container())
        $wrapper.find('.dataTables_paginate').toggle(api.page.info().pages > 1)
    })
}

// Sustituye el <select> nativo de "registros por página" (feo/no
// personalizable entre navegadores) por un desplegable a medida con la
// estética de marca. Se llama a mano justo después de cada
// .dataTable()/.DataTable(), ya que jQuery no dispara ningún evento propio
// reutilizable para "el select ya está en el DOM" en todos los casos.
export function enhanceDataTableLength () {
    const $ = window.$
    if (!$) return
    $('.dataTables_length select').each(function () {
        const $select = $(this)
        if ($select.data('cdEnhanced')) return
        $select.data('cdEnhanced', true)

        const $wrapper = $('<div class="cd-select"></div>')
        const $toggle = $('<button type="button" class="cd-select__toggle"></button>')
        const $label = $('<span class="cd-select__label"></span>').text($select.find('option:selected').text())
        const $chevron = $('<i class="cd-select__chevron"></i>')
        const $panel = $('<div class="cd-select__panel"></div>')

        function close () { $wrapper.removeClass('cd-select--open') }
        function open () { $wrapper.addClass('cd-select--open') }

        $select.find('option').each(function () {
            const $opt = $(this)
            const $item = $('<div class="cd-select__option"></div>')
                .text($opt.text())
                .toggleClass('cd-select__option--active', $opt.is(':selected'))
                .on('click', function () {
                    $select.val($opt.val()).trigger('change')
                    $panel.find('.cd-select__option').removeClass('cd-select__option--active')
                    $item.addClass('cd-select__option--active')
                    $label.text($opt.text())
                    close()
                })
            $panel.append($item)
        })

        $toggle.on('click', function (e) {
            e.stopPropagation()
            $wrapper.hasClass('cd-select--open') ? close() : open()
        })
        $(document).on('click', close)

        $toggle.append($label, $chevron)
        $wrapper.append($toggle, $panel)
        $select.hide().after($wrapper)
    })
}

export const apiCallList =
{
    data ()
    {
        return {
            error: false,
            data: null,
            items: [],
            loading: false,
            server_error: null
            // currentNewsPage: 1,
            // maxPages: 0,
            // show_all : '',
            // search : null
        }
    },
    created ()
    {
        this.fetch ();
    },
    methods:
    {
        fetch ()
        {
            this.$store.dispatch ('isLoadingOn');
            this.$axios.get (`/${this.endpoint}`)
            // this.$axios.get (`/${this.endpoint}?items=12&page=${this.currentNewsPage}${this.show_all}${search}`)
            .then ((response) =>
            {
                this.$store.dispatch ('isLoadingOff');
                this.data = response.data;
                // this.maxPages = response.data.pagination.totalPages;
                // if (this.maxPages < this.currentNewsPage) this.currentNewsPage = 1;
                this.loadItems ();
            })
            .catch (() =>
            {
                this.$store.dispatch ('isLoadingOff');
                this.data = [];
                this.loadItems ();
            })
        }
        // changePage (pageNum)
        // {
        //     this.page.current = pageNum;
        //     this.fetch (this.page.current);
        // },
        // loadPage (page)
        // {
        //     this.currentNewsPage = page;
        //     this.fetch ();
        // },
        // updateparent ()
        // {
        //     this.fetch ();
        // }
    }
}

export const apiCallSingle =
{
    data ()
    {
        return {
            type: this.$t ('Add'),
            error: false,
            loading: false,
            server_error: null
        }
    },
    async created ()
    {
        if (this.id)
        {
            this.type =  this.$t ('Edit');
            await this.fetch ();
        }
    },
    methods:
    {
        async fetch ()
        {
            this.$store.dispatch ('isLoadingOn');
            let self = this;
            return new Promise (function (resolve)
            {
                self.$axios.get (`/${self.endpoint}/${self.id}`)
                .then (
                    response =>
                    {
                        self.data = response.data;
                        self.loadData ();
                        self.$store.dispatch ('isLoadingOff');
                        resolve ();
                    }
                )
                .catch (
                    (error) =>
                    {
                        self.error = error
                        self.$store.dispatch ('isLoadingOff');
                        resolve ();
                    }
                )
            });
        },
        submit ()
        {
            this.server_error = '';
            this.error = false;
            this.loading = true;
            this.$v.$touch ();
            if (!this.$v.$invalid) this.onSave ();
            else
            {
                let error_list = "<li>Complete los campos del formulario.</li>";
                this.setError (error_list);
            }  
        },
        onSave ()
        {            
            let action;
            const properties = this.getProperties ();
            this.$store.dispatch ('isLoadingOn');
            if (this.id) action = this.$axios.put (`/${this.endpoint}/${this.id}`, properties);
            else action = this.$axios.post (`/${this.endpoint}`, properties);
            action
            .then (() =>
            {
                this.$store.dispatch ('isLoadingOff');
                // let data = response.data.data;
                this.$dialog
                .alert (
                {
                    title: this.title,
                    body: this.$t ("save_complete")
                })
                .then (() =>
                {
                    this.$router.push ('/' + this.section)
                });              
            })
            .catch (async (err) =>
            {
                this.$store.dispatch ('isLoadingOff');

                // A user or a bulletin refused for a contracted limit gets its
                // own warning instead of the error line of the form.
                if (await handleLimitError (this, err))
                {
                    this.loading = false;
                    return;
                }

                let error_list = '';
                // The API answers Laravel's plain {message}: there is no result
                // in it, and reading through one threw inside this very catch,
                // so the form never showed any error at all.
                const data = (err.response && err.response.data) || {};
                const result = data.result || {};
                const validationMessages = result.validationErrors ? result.validationErrors.messages : null;
                const otherMessages = result.otherErrors ? result.otherErrors.message : null;
                if (validationMessages && Object.keys (validationMessages).length > 0)
                {
                    let error = validationMessages;
                    Object.values (error).forEach (
                        item =>
                        {
                            error_list += '<li>' + item + '</li>';
                        }
                    )
                }
                else if (result.Errors && result.Errors.length > 0) error_list = result.Errors.message;
                else if (otherMessages && otherMessages.length > 0)
                {
                    let error = otherMessages;
                    Object.values (error).forEach (
                        item =>
                        {
                            error_list += '<li>' + item + '</li>';
                        }
                    )
                }
                else
                {
                    if (this.section == "admin/templates") this.templateFields (err.response);
                    else error_list = data.message || this.$t ("server_error");
                }
                this.setError (error_list);
            })
        },
        toggleActive (toggle)
        {
            this.properties.active = toggle.value;
        },
        setError (error_list)
        {
            this.loading = false;
            this.buton_text = 'Enviar'
            this.error = true;
            this.server_error = error_list;
        }
    }
}